import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, ShieldAlert } from 'lucide-react';
import './ErrorPages.css';

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-animation">
          <div className="error-icon-wrapper forbidden">
            <ShieldAlert size={80} className="error-icon" />
          </div>
        </div>

        <h1 className="error-code">403</h1>
        <h2 className="error-title">Access Denied</h2>
        <p className="error-description">
          You don't have permission to access this resource. Please contact your administrator if you believe this is an error.
        </p>

        <div className="error-actions">
          <Link to="/" className="error-button primary">
            <Home size={20} />
            <span>Go Home</span>
          </Link>
          <button onClick={() => navigate(-1)} className="error-button secondary">
            <ArrowLeft size={20} />
            <span>Go Back</span>
          </button>
        </div>

        <div className="error-help">
          <p>Need access? <a href="mailto:admin@tech360.com">Request Permissions</a></p>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
